/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, G } from 'react-native-svg';

import { IconProps } from '../lib';

function SquaresFour(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <G>
        <Rect x={40} y={40} width={80} height={80} rx={8} />
        <Rect x={136} y={40} width={80} height={80} rx={8} />
        <Rect x={40} y={136} width={80} height={80} rx={8} />
        <Rect x={136} y={136} width={80} height={80} rx={8} />
      </G>
    </Svg>
  );
}

export default SquaresFour;
